import { IActionResult } from '../types/IActionResult';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ISyncActiveDirectoryGroupParams {
  name: string; // group name
  domainName: string; // group's domain name
  siteRole: string; // site role given to new users
}

export interface ISyncAdGroupCompleteResult extends IResult {
  usersAddedToGroup: number;
  usersAddedToSite: number;
  usersInActiveDirectoryGroup: number;
  usersProcessed: number;
  usersRemovedFromGroup: number;
  usersSiteRoleUpdated: number;
  usersSkipped: number;
  usersUnlicensed: number;
  usersUpdated: number;
  usersWithInsufficientLicenses: number;
}

export class SyncActiveDirectoryGroupRequest extends Request<ISyncActiveDirectoryGroupParams, IActionResult> {
  constructor(params: ISyncActiveDirectoryGroupParams) {
    super('syncActiveDirectoryGroup', params);
  }
}
